import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_XMAS_70: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_XMAS_70,
  },
  {
    pageId: PageId.CHAT_UPSELL_XMAS_70,
  },
  {
    pageId: PageId.UPSELL_XMAS_70,
  },
  {
    pageId: PageId.DOWNLOAD_XMAS_70,
  },
  {
    pageId: PageId.ACCOUNT_NOVE8,
  },
]
